import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../../assets/css/style.css";
import ELI from "../../assets/img/ELI LOGO.png";
import { jwtDecode } from "jwt-decode";
import useCompanyProfile from "../../hooks/customHook/useCompanyProfile";

const Sidebar = ({ authrztn }) => {
  const location = useLocation();
  const [userLoggedID, setUserLoggedID] = useState([]);
  const { company, loading } = useCompanyProfile();
  const [isZoomed, setIsZoomed] = useState(false); // Tracks 200% zoom state

  const decodeToken = () => {
    var token = localStorage.getItem("accessToken");
    if (typeof token === "string") {
      var decoded = jwtDecode(token);
      // console.log("DECODED TOKEN:", decoded);
      setUserLoggedID(decoded.id);
    }
  };
  useEffect(() => {
    decodeToken();
  }, []);

  // sidebar btn
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // Initial state set to closed
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen); // Toggles between true (open) and false (closed)
  };

  // Auto-collapse the sidebar once the effective viewport drops below the
  // same 850px breakpoint style.css uses. Browser zoom shrinks
  // window.innerWidth the same way a narrower window does, so this covers
  // "zoomed in too much" and "window resized smaller" the same way. Without
  // this, an already-open sidebar (.sidebar.open) stays locked at 300px no
  // matter how far the effective viewport keeps shrinking, since only the
  // *default* (not-open) state collapses on its own via the CSS media query.
  useEffect(() => {
    const mql = window.matchMedia("(max-width: 850px)");

    const handleChange = (e) => {
      setIsZoomed(e.matches);
      if (e.matches) {
        setIsSidebarOpen(false); // Close automatically when zooming in
      } else {
        setIsSidebarOpen(true); // Open automatically when going back to normal
      }
    };

    // Set initial states on mount
    setIsZoomed(mql.matches);
    setIsSidebarOpen(!mql.matches);

    mql.addEventListener("change", handleChange);
    return () => mql.removeEventListener("change", handleChange);
  }, []);

  const [inventoryOpen, setInventoryOpen] = useState(false);
  const [accountingOpen, setAccountingOpen] = useState(false);
  const [salesOpen, setSalesOpen] = useState(false);
  const [purchasesOpen, setPurchasesOpen] = useState(false);
  const [accountsOpen, setAccountsOpen] = useState(false);
  const [contentOpen, setContentOpen] = useState(false);
  const [taxMngntOpen, setTaxMngntOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [reportingOpen, setReportingOpen] = useState(false);
  const [statementReportsOpen, setStatementReportsOpen] = useState(false);
  const [auditReportsOpen, setAuditReportsOpen] = useState(false);
  const [businessPartnerReportsOpen, setBusinessPartnerReportsOpen] =
    useState(false);
  const [generalReportsOpen, setGeneralReportsOpen] = useState(false);
  const [newReportsOpen, setNewReportsOpen] = useState(false);
  const [flyoutMenu, setFlyoutMenu] = useState(null);
  // flyoutMenu: { key: string, top: number } | null
  const flyoutRef = useRef(null);
  // Corrected top for the CURRENTLY open flyout, once measured; null
  // until then (so we fall back to the raw icon position for that
  // first paint).
  const [flyoutTop, setFlyoutTop] = useState(null);

  // Some flyouts (Reporting, Accounting, ...) have a lot of links. If
  // one opens low enough on a short screen, flyoutMenu.top plus its
  // real height can run past the bottom of the viewport with nothing
  // to scroll it into view. Once the flyout is in the DOM, measure it
  // and, if needed, shift it up so it stays fully on screen. The
  // .sidebar-flyout max-height/overflow-y in style.css is the fallback
  // for lists still taller than the viewport itself.
  //
  // Also re-run on window "resize", not just on open: browser zoom
  // fires resize (it changes window.innerHeight). If the person zooms
  // further AFTER the flyout is already open, the top computed at
  // open-time goes stale -- the box's own bottom edge can end up past
  // the new, smaller viewport even though its internal scrollbar still
  // reports more content below (scrolls, but not "enough").
  useLayoutEffect(() => {
    if (!flyoutMenu) {
      setFlyoutTop(null);
      return;
    }
    const margin = 12;
    const reposition = () => {
      if (!flyoutRef.current) return;
      const flyoutHeight = flyoutRef.current.offsetHeight;
      const maxTop = Math.max(
        margin,
        window.innerHeight - flyoutHeight - margin,
      );
      setFlyoutTop(Math.min(flyoutMenu.top, maxTop));
    };
    reposition();
    window.addEventListener("resize", reposition);
    return () => window.removeEventListener("resize", reposition);
  }, [flyoutMenu]);
  const hasPageParam = location.search.includes("page=");

  useEffect(() => {
    // Check and open the submenu if the current path matches any of its links
    if (location.pathname.startsWith("/inventory")) {
      if (!location.pathname.startsWith("/reports/inventory-report")) {
        setInventoryOpen(true);
        setAccountingOpen(false);
        setSalesOpen(false);
        setPurchasesOpen(false);
        setReportingOpen(false);
        setStatementReportsOpen(false);
        setAuditReportsOpen(false);
        setBusinessPartnerReportsOpen(false);
        setGeneralReportsOpen(false);
        setAccountsOpen(false);
        setContentOpen(false);
        setSettingsOpen(false);

        setNewReportsOpen(false);
        setTaxMngntOpen(false);
      }
    } else if (location.pathname.startsWith("/accounting")) {
      setAccountingOpen(true);
      setInventoryOpen(false);
      setSalesOpen(false);
      setPurchasesOpen(false);
      setReportingOpen(false);
      setStatementReportsOpen(false);
      setAuditReportsOpen(false);
      setBusinessPartnerReportsOpen(false);
      setGeneralReportsOpen(false);
      setContentOpen(false);
      setSettingsOpen(false);

      setNewReportsOpen(false);
      setTaxMngntOpen(false);
    } else if (location.pathname.startsWith("/accounts")) {
      setAccountsOpen(true);
      setInventoryOpen(false);
      setSalesOpen(false);
      setPurchasesOpen(false);
      setReportingOpen(false);
      setStatementReportsOpen(false);
      setAuditReportsOpen(false);
      setBusinessPartnerReportsOpen(false);
      setGeneralReportsOpen(false);
      setAccountingOpen(false);
      setSettingsOpen(false);

      setNewReportsOpen(false);
      setTaxMngntOpen(false);
    } else if (location.pathname.startsWith("/settings")) {
      setSettingsOpen(true);
      setAccountingOpen(false);
      setInventoryOpen(false);
      setSalesOpen(false);
      setPurchasesOpen(false);
      setReportingOpen(false);
      setStatementReportsOpen(false);
      setAuditReportsOpen(false);
      setBusinessPartnerReportsOpen(false);
      setGeneralReportsOpen(false);
      setAccountingOpen(false);

      setNewReportsOpen(false);
      setTaxMngntOpen(false);
    } else if (location.pathname.startsWith("/taxmngnt")) {
      setContentOpen(false);
      setAccountingOpen(false);
      setInventoryOpen(false);
      setSalesOpen(false);
      setPurchasesOpen(false);
      setReportingOpen(false);
      setStatementReportsOpen(false);
      setAuditReportsOpen(false);
      setBusinessPartnerReportsOpen(false);
      setGeneralReportsOpen(false);
      setSettingsOpen(false);

      setNewReportsOpen(false);
      setTaxMngntOpen(true);
    } else if (location.pathname.startsWith("/content")) {
      setContentOpen(true);
      setAccountingOpen(false);
      setInventoryOpen(false);
      setSalesOpen(false);
      setPurchasesOpen(false);
      setReportingOpen(false);
      setStatementReportsOpen(false);
      setAuditReportsOpen(false);
      setBusinessPartnerReportsOpen(false);
      setGeneralReportsOpen(false);
      setSettingsOpen(false);

      setNewReportsOpen(false);
      setTaxMngntOpen(false);
    } else if (location.pathname.startsWith("/sales")) {
      setSalesOpen(true);
      setInventoryOpen(false);
      setAccountingOpen(false);
      setPurchasesOpen(false);
      setReportingOpen(false);
      setStatementReportsOpen(false);
      setAuditReportsOpen(false);
      setBusinessPartnerReportsOpen(false);
      setGeneralReportsOpen(false);
      setAccountsOpen(false);
      setContentOpen(false);
      setSettingsOpen(false);

      setNewReportsOpen(false);
      setTaxMngntOpen(false);
    } else if (
      location.pathname.startsWith("/purchases") ||
      location.pathname.startsWith("/Purchases")
    ) {
      setPurchasesOpen(true);
      setInventoryOpen(false);
      setAccountingOpen(false);
      setSalesOpen(false);
      setReportingOpen(false);
      setStatementReportsOpen(false);
      setAuditReportsOpen(false);
      setBusinessPartnerReportsOpen(false);
      setGeneralReportsOpen(false);
      setAccountsOpen(false);
      setContentOpen(false);
      setSettingsOpen(false);

      setNewReportsOpen(false);
      setTaxMngntOpen(false);
    } else if (location.pathname.startsWith("/reports")) {
      setReportingOpen(true);
      setInventoryOpen(false);
      setAccountingOpen(false);
      setSalesOpen(false);
      setPurchasesOpen(false);
      setTaxMngntOpen(false);
      if (location.pathname.startsWith("/reports/statement")) {
        setStatementReportsOpen(true);
        setAuditReportsOpen(false);
        setBusinessPartnerReportsOpen(false);
        setGeneralReportsOpen(false);
      } else if (location.pathname.startsWith("/reports/audit")) {
        setStatementReportsOpen(false);
        setAuditReportsOpen(true);
        setBusinessPartnerReportsOpen(false);
        setGeneralReportsOpen(false);
      } else if (location.pathname.startsWith("/reports/business-partner")) {
        setStatementReportsOpen(false);
        setAuditReportsOpen(false);
        setBusinessPartnerReportsOpen(true);
        setGeneralReportsOpen(false);
      } else if (location.pathname.startsWith("/reports/general")) {
        setStatementReportsOpen(false);
        setAuditReportsOpen(false);
        setBusinessPartnerReportsOpen(false);
        setGeneralReportsOpen(true);
      } else if (location.pathname.startsWith("/reports/new-report")) {
        setStatementReportsOpen(false);
        setAuditReportsOpen(false);
        setBusinessPartnerReportsOpen(false);
        setGeneralReportsOpen(false);

        setNewReportsOpen(true);
      } else {
        setStatementReportsOpen(false);
        setAuditReportsOpen(false);
        setBusinessPartnerReportsOpen(false);
        setGeneralReportsOpen(false);
      }
    } else {
      setInventoryOpen(false);
      setAccountingOpen(false);
      setSalesOpen(false);
      setPurchasesOpen(false);
      setReportingOpen(false);
      setStatementReportsOpen(false);
      setAuditReportsOpen(false);
      setBusinessPartnerReportsOpen(false);
      setGeneralReportsOpen(false);
      setAccountsOpen(false);
      setContentOpen(false);
      setSettingsOpen(false);

      setNewReportsOpen(false);
      setTaxMngntOpen(false);
    }
  }, [location.pathname]);

  // Close flyout when clicking outside
  useEffect(() => {
    if (!flyoutMenu) return;
    const close = () => setFlyoutMenu(null);
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, [flyoutMenu]);

  const toggleSubMenu = (subMenu) => {
    switch (subMenu) {
      case "inventory":
        setInventoryOpen(!inventoryOpen);
        setAccountingOpen(false);
        setSalesOpen(false);
        setPurchasesOpen(false);
        setReportingOpen(false);
        setStatementReportsOpen(false);
        setAuditReportsOpen(false);
        setBusinessPartnerReportsOpen(false);
        setGeneralReportsOpen(false);
        setAccountsOpen(false);
        setContentOpen(false);
        setSettingsOpen(false);

        setNewReportsOpen(false);
        setTaxMngntOpen(false);
        break;
      case "accounting":
        setAccountingOpen(!accountingOpen);
        setInventoryOpen(false);
        setSalesOpen(false);
        setPurchasesOpen(false);
        setReportingOpen(false);
        setStatementReportsOpen(false);
        setAuditReportsOpen(false);
        setBusinessPartnerReportsOpen(false);
        setGeneralReportsOpen(false);
        setAccountsOpen(false);
        setContentOpen(false);
        setSettingsOpen(false);

        setNewReportsOpen(false);
        setTaxMngntOpen(false);
        break;
      case "settings":
        setSettingsOpen(!settingsOpen);
        setAccountingOpen(false);
        setInventoryOpen(false);
        setSalesOpen(false);
        setPurchasesOpen(false);
        setReportingOpen(false);
        setStatementReportsOpen(false);
        setAuditReportsOpen(false);
        setBusinessPartnerReportsOpen(false);
        setGeneralReportsOpen(false);
        setAccountsOpen(false);
        setContentOpen(false);

        setNewReportsOpen(false);
        setTaxMngntOpen(false);
        break;
      case "accounts":
        // Toggle accountsOpen to control visibility of Accounting tabs
        setAccountsOpen(!accountsOpen);
        setAccountingOpen(false); // Set accountingOpen based on accountsOpen state
        setInventoryOpen(false);
        setSalesOpen(false);
        setPurchasesOpen(false);
        setReportingOpen(false);
        setStatementReportsOpen(false);
        setAuditReportsOpen(false);
        setBusinessPartnerReportsOpen(false);
        setGeneralReportsOpen(false);
        setContentOpen(false);
        setSettingsOpen(false);

        setNewReportsOpen(false);
        setTaxMngntOpen(false);
        break;
      case "content":
        setContentOpen(!contentOpen);
        setInventoryOpen(false);
        setSalesOpen(false);
        setPurchasesOpen(false);
        setReportingOpen(false);
        setStatementReportsOpen(false);
        setAuditReportsOpen(false);
        setBusinessPartnerReportsOpen(false);
        setGeneralReportsOpen(false);
        setAccountsOpen(false);
        setAccountingOpen(false);
        setSettingsOpen(false);

        setNewReportsOpen(false);
        setTaxMngntOpen(false);
        break;
      case "sales":
        setSalesOpen(!salesOpen);
        setInventoryOpen(false);
        setAccountingOpen(false);
        setPurchasesOpen(false);
        setReportingOpen(false);
        setStatementReportsOpen(false);
        setAuditReportsOpen(false);
        setBusinessPartnerReportsOpen(false);
        setGeneralReportsOpen(false);
        setAccountsOpen(false);
        setContentOpen(false);
        setSettingsOpen(false);

        setNewReportsOpen(false);
        setTaxMngntOpen(false);
        break;
      case "taxmngnt":
        setTaxMngntOpen(!taxMngntOpen);
        setPurchasesOpen(false);
        setInventoryOpen(false);
        setAccountingOpen(false);
        setSalesOpen(false);
        setReportingOpen(false);
        setStatementReportsOpen(false);
        setAuditReportsOpen(false);
        setBusinessPartnerReportsOpen(false);
        setGeneralReportsOpen(false);
        setAccountsOpen(false);
        setContentOpen(false);
        setSettingsOpen(false);

        setNewReportsOpen(false);
        break;
      case "purchases":
        setPurchasesOpen(!purchasesOpen);
        setInventoryOpen(false);
        setAccountingOpen(false);
        setSalesOpen(false);
        setReportingOpen(false);
        setStatementReportsOpen(false);
        setAuditReportsOpen(false);
        setBusinessPartnerReportsOpen(false);
        setGeneralReportsOpen(false);
        setAccountsOpen(false);
        setContentOpen(false);
        setSettingsOpen(false);

        setNewReportsOpen(false);
        setTaxMngntOpen(false);
        break;
      case "reports":
        setReportingOpen(!reportingOpen);
        setInventoryOpen(false);
        setAccountingOpen(false);
        setSalesOpen(false);
        setPurchasesOpen(false);
        setContentOpen(false);
        setSettingsOpen(false);
        // For Reports submenu, reset all other submenus
        setStatementReportsOpen(false);
        setAuditReportsOpen(false);
        setBusinessPartnerReportsOpen(false);
        setGeneralReportsOpen(false);
        setAccountsOpen(false);

        setNewReportsOpen(false);
        setTaxMngntOpen(false);
        break;
      case "statementReports":
        setStatementReportsOpen(!statementReportsOpen);
        setAuditReportsOpen(false);
        setBusinessPartnerReportsOpen(false);
        setGeneralReportsOpen(false);
        setNewReportsOpen(false);
        break;
      case "auditReports":
        setStatementReportsOpen(false);
        setAuditReportsOpen(!auditReportsOpen);
        setBusinessPartnerReportsOpen(false);
        setGeneralReportsOpen(false);
        setNewReportsOpen(false);
        break;
      case "businessPartnerReports":
        setStatementReportsOpen(false);
        setAuditReportsOpen(false);
        setBusinessPartnerReportsOpen(!businessPartnerReportsOpen);
        setGeneralReportsOpen(false);
        setNewReportsOpen(false);
        break;
      case "generalReports":
        setStatementReportsOpen(false);
        setAuditReportsOpen(false);
        setBusinessPartnerReportsOpen(false);
        setGeneralReportsOpen(!generalReportsOpen);
        setNewReportsOpen(false);
        break;
      case "newReports":
        setStatementReportsOpen(false);
        setAuditReportsOpen(false);
        setBusinessPartnerReportsOpen(false);
        setGeneralReportsOpen(false);
        setNewReportsOpen(!newReportsOpen);
        break;
      default:
        break;
    }
  };

  // Whether the sidebar is currently rendered as the icon-only 80px strip.
  // Desktop view (effective width > 850px): icon-only when NOT open
  // (isSidebarOpen === false -> .sidebar.closed -> 80px, see style.css).
  // Zoomed/narrow view (<=850px effective width, see the auto-collapse
  // effect above): the CSS meaning of open/closed flips at that
  // breakpoint -- .sidebar.open becomes the 80px icon-only strip and
  // .sidebar.closed becomes width:0 (fully hidden). So icon-only there
  // means isSidebarOpen === true instead. isIconOnly tracks whichever of
  // those is actually on screen, so flyout-vs-inline-toggle stays correct
  // in both views.
  const isIconOnly = isZoomed ? isSidebarOpen : !isSidebarOpen;

  // When icon-only: show flyout popup. When fully expanded: normal toggle.
  const handleNavClick = (e, menuKey) => {
    if (isIconOnly) {
      e.stopPropagation();
      const rect = e.currentTarget.getBoundingClientRect();
      setFlyoutMenu(
        flyoutMenu?.key === menuKey ? null : { key: menuKey, top: rect.top },
      );
    } else {
      setFlyoutMenu(null);
      toggleSubMenu(menuKey);
    }
  };

  const renderFlyout = (key) => {
    const closeFlyout = () => setFlyoutMenu(null);
    switch (key) {
      case "sales":
        return (
          <>
            <div className="sidebar-flyout-title">Sales Order</div>
            {authrztn.includes("Invoices-View") && (
              <Link
                to="/sales/invoices"
                className="nav-link"
                onClick={closeFlyout}
              >
                Sales Management
              </Link>
            )}
            {authrztn.includes("LocalCollections-View") && (
              <Link
                to="/sales/local-collections"
                className="nav-link"
                onClick={closeFlyout}
              >
                Sales Collection
              </Link>
            )}
            {authrztn.includes("Customers-View") && (
              <Link
                to="/sales/customers"
                className="nav-link"
                onClick={closeFlyout}
              >
                Customers
              </Link>
            )}
          </>
        );
      case "purchases":
        return (
          <>
            <div className="sidebar-flyout-title">Purchase Order</div>
            {authrztn.includes("Payable-View") && (
              <Link
                to="/purchases/payable"
                className="nav-link"
                onClick={closeFlyout}
              >
                Purchase Management
              </Link>
            )}
            {authrztn.includes("LocalPurchase-View") && (
              <Link
                to="/purchases/local-purchase"
                className="nav-link"
                onClick={closeFlyout}
              >
                Purchase
              </Link>
            )}
            {authrztn.includes("Vendors-View") && (
              <Link
                to="/purchases/vendors"
                className="nav-link"
                onClick={closeFlyout}
              >
                Supplier
              </Link>
            )}
          </>
        );
      case "accounts":
        return (
          <>
            <div className="sidebar-flyout-title">Cash Account</div>
            {authrztn.includes("BankTransactions-View") && (
              <Link
                to="/accounts/bank-transaction"
                className="nav-link"
                onClick={closeFlyout}
              >
                Bank Transactions
              </Link>
            )}
            {authrztn.includes("OutstandingCheck-View") && (
              <Link
                to="/accounts/outstanding-check"
                className="nav-link"
                onClick={closeFlyout}
              >
                Receivable Checks
              </Link>
            )}
            {authrztn.includes("IssuedCheck-View") && (
              <Link
                to="/accounts/issued-check-account"
                className="nav-link"
                onClick={closeFlyout}
              >
                Issued Checks
              </Link>
            )}
            {authrztn.includes("AccountingList-View") && (
              <Link
                to="/accounts/account-list1"
                className="nav-link"
                onClick={closeFlyout}
              >
                Accounting List
              </Link>
            )}
            {authrztn.includes("BankBudgeting-View") && (
              <Link
                to="/accounts/bank-budgeting"
                className="nav-link"
                onClick={closeFlyout}
              >
                Bank Budgeting
              </Link>
            )}
            {authrztn.includes("OtherIncome-View") && (
              <Link
                to="/accounts/other-income"
                className="nav-link"
                onClick={closeFlyout}
              >
                Other Income
              </Link>
            )}
          </>
        );
      case "inventory":
        return (
          <>
            <div className="sidebar-flyout-title">Inventory</div>
            {authrztn.includes("StockManagement-View") && (
              <Link
                to="/inventory/stock-management"
                className="nav-link"
                onClick={closeFlyout}
              >
                Stock Management
              </Link>
            )}
            {authrztn.includes("ProductList-View") && (
              <Link
                to="/inventory/product-list"
                className="nav-link"
                onClick={closeFlyout}
              >
                Product List
              </Link>
            )}
            {authrztn.includes("Productions-View") && (
              <Link
                to="/inventory/productions"
                className="nav-link"
                onClick={closeFlyout}
              >
                Production
              </Link>
            )}
            {authrztn.includes("StockTransfer-View") && (
              <Link
                to="/inventory/stock-transfer"
                className="nav-link"
                onClick={closeFlyout}
              >
                Stock Transfer
              </Link>
            )}
            {authrztn.includes("InventoryCounting-View") && (
              <Link
                to="/inventory/inventory-counting"
                className="nav-link"
                onClick={closeFlyout}
              >
                Inventory Counting
              </Link>
            )}
          </>
        );
      case "accounting":
        return (
          <>
            <div className="sidebar-flyout-title">Accounting</div>
            {authrztn.includes("CashFlow-View") && (
              <Link
                to="/accounting/cash-flow"
                className="nav-link"
                onClick={closeFlyout}
              >
                Cash Flow
              </Link>
            )}
            {authrztn.includes("Expenses-View") && (
              <Link
                to="/accounting/expenses"
                className="nav-link"
                onClick={closeFlyout}
              >
                Create Expenses
              </Link>
            )}
            {authrztn.includes("LocalExpenses-View") && (
              <Link
                to="/accounting/local-expenses"
                className="nav-link"
                onClick={closeFlyout}
              >
                Closed Expenses
              </Link>
            )}
            {authrztn.includes("FixedAssets-View") && (
              <Link
                to="/accounting/fixedAsset"
                className="nav-link"
                onClick={closeFlyout}
              >
                Fixed Assets
              </Link>
            )}
            {authrztn.includes("AssetAccount-View") && (
              <Link
                to="/accounting/assetaccount-list1"
                className="nav-link"
                onClick={closeFlyout}
              >
                Asset Account
              </Link>
            )}
            {authrztn.includes("Liability-View") && (
              <Link
                to="/accounting/liabilities1"
                className="nav-link"
                onClick={closeFlyout}
              >
                Liabilities
              </Link>
            )}
            {authrztn.includes("Equity-View") && (
              <Link
                to="/accounting/equity"
                className="nav-link"
                onClick={closeFlyout}
              >
                Owners' Equity
              </Link>
            )}
            {authrztn.includes("Monthly-View") && (
              <Link
                to="/accounting/cutoff"
                className="nav-link"
                onClick={closeFlyout}
              >
                Monthly Accounting Cutoff
              </Link>
            )}
          </>
        );
      case "taxmngnt":
        return (
          <>
            <div className="sidebar-flyout-title">Tax Management</div>
            <Link
              to="/taxmngnt/tax-settings"
              className="nav-link"
              onClick={closeFlyout}
            >
              Withholding Tax Settings
            </Link>
            <span
              className="nav-link"
              style={{ cursor: "not-allowed", color: "#aaa" }}
            >
              Withholding Tax Report <i className="fa-solid fa-lock"></i>
            </span>
          </>
        );
      case "reports":
        return (
          <>
            <div className="sidebar-flyout-title">Reporting</div>
            {authrztn.includes("BossReport-View") && (
              <Link
                to="/reports/general/boss-report"
                className="nav-link"
                onClick={closeFlyout}
              >
                Boss Report
              </Link>
            )}
            {(authrztn.includes("PurchaseReport-View") ||
              authrztn.includes("ProductionReport-View") ||
              authrztn.includes("SalesReport-View") ||
              authrztn.includes("InventoryReport-View") ||
              authrztn.includes("ExpensesReport-View") ||
              authrztn.includes("IncomeStatement-View") ||
              authrztn.includes("BalanceSheet-View") ||
              authrztn.includes("ProfitLoss-View") ||
              authrztn.includes("AccountReport-View") ||
              authrztn.includes("UserReport-View")) && (
              <div className="sidebar-flyout-section">Standard Reports</div>
            )}
            {authrztn.includes("PurchaseReport-View") && (
              <Link
                to="/reports/new-report/purchase_report"
                className="nav-link"
                onClick={closeFlyout}
              >
                Purchase Report
              </Link>
            )}
            {authrztn.includes("ProductionReport-View") && (
              <Link
                to="/reports/new-report/production_report"
                className="nav-link"
                onClick={closeFlyout}
              >
                Production Report
              </Link>
            )}
            {authrztn.includes("SalesReport-View") && (
              <Link
                to="/reports/new-report/sales_report"
                className="nav-link"
                onClick={closeFlyout}
              >
                Sales Report
              </Link>
            )}
            {authrztn.includes("InventoryReport-View") && (
              <Link
                to="/reports/new-report/inventory_report"
                className="nav-link"
                onClick={closeFlyout}
              >
                Inventory Report
              </Link>
            )}
            {authrztn.includes("ExpensesReport-View") && (
              <Link
                to="/reports/new-report/expenses_report"
                className="nav-link"
                onClick={closeFlyout}
              >
                Expenses Report
              </Link>
            )}
            {authrztn.includes("IncomeStatement-View") && (
              <Link
                to="/reports/new-report/income_statement"
                className="nav-link"
                onClick={closeFlyout}
              >
                Income Statement
              </Link>
            )}
            {authrztn.includes("BalanceSheet-View") && (
              <Link
                to="/reports/new-report/balance_sheet"
                className="nav-link"
                onClick={closeFlyout}
              >
                Balance Sheet
              </Link>
            )}
            {authrztn.includes("ProfitLoss-View") && (
              <Link
                to="/reports/new-report/profit_loss"
                className="nav-link"
                onClick={closeFlyout}
              >
                Foreign Gain/Loss
              </Link>
            )}
            {authrztn.includes("AccountReport-View") && (
              <Link
                to="/reports/new-report/account_reports"
                className="nav-link"
                onClick={closeFlyout}
              >
                Account Reports
              </Link>
            )}
            {authrztn.includes("UserReport-View") && (
              <Link
                to="/reports/new-report/user_reports"
                className="nav-link"
                onClick={closeFlyout}
              >
                User Reports
              </Link>
            )}
          </>
        );
      case "content":
        return (
          <>
            <div className="sidebar-flyout-title">Content Management</div>
            {authrztn.includes("ExpensesType1-View") && (
              <Link
                to="/content/expenses1"
                className="nav-link"
                onClick={closeFlyout}
              >
                Expense Type
              </Link>
            )}
            {authrztn.includes("ExpensesType2-View") && (
              <Link
                to="/content/expenses2"
                className="nav-link"
                onClick={closeFlyout}
              >
                Expense Sub-Type
              </Link>
            )}
          </>
        );
      case "settings":
        return (
          <>
            <div className="sidebar-flyout-title">Settings</div>
            {authrztn.includes("RBAC-View") && (
              <Link
                to="/settings/access-control"
                className="nav-link"
                onClick={closeFlyout}
              >
                Access Control
              </Link>
            )}
            {userLoggedID === "11111111-1111-1111-1111-111111111111" &&
              authrztn.includes("Branches-View") && (
                <Link
                  to="/settings/branches"
                  className="nav-link"
                  onClick={closeFlyout}
                >
                  Company Branches
                </Link>
              )}
            {authrztn.includes("UserManagement-View") && (
              <Link
                to="/settings/user-management"
                className="nav-link"
                onClick={closeFlyout}
              >
                User Management
              </Link>
            )}
            {userLoggedID === "11111111-1111-1111-1111-111111111111" &&
              authrztn.includes("Currency-View") && (
                <Link
                  to="/settings/currency"
                  className="nav-link"
                  onClick={closeFlyout}
                >
                  Currency
                </Link>
              )}
            {authrztn.includes("Notifications-View") && (
              <Link
                to="/settings/in-app-notification"
                className="nav-link"
                onClick={closeFlyout}
              >
                In-app Notification
              </Link>
            )}
          </>
        );
      default:
        return null;
    }
  };

  return (
    <>
      {/* Sidebar Toggle Button - Moved outside .sidebar */}
      <div
        className={`sidebar-toggle ${isSidebarOpen ? "toggle-open" : "toggle-closed"}`}
        onClick={toggleSidebar}
      >
        <i
          className={`fas ${
            isZoomed
              ? isSidebarOpen
                ? "fa-times" /* 'X' when open in 200% zoom */
                : "fa-bars" /* '3 bars' when closed in 200% zoom */
              : isSidebarOpen
                ? "fa-angle-left" /* '<' when open in normal view */
                : "fa-angle-right" /* '>' when closed in normal view */
          }`}
        ></i>
      </div>

      <div
        className={`sidebar scrollable-contents shadow rounded d-flex flex-column bg-light border-right ${
          isSidebarOpen ? "open" : "closed"
        }`}
      >
        {/* Divider aligned with navbar's 6rem border-bottom */}
        <div className="sidebar-navbar-divider" />

        <div className="p-3">
          <div className="logo-container d-flex align-items-center justify-content-center mb-2">
            <img
              src={
                !loading && company && company.profile_picture
                  ? `data:image/jpeg;base64,${company.profile_picture}`
                  : ELI
              }
              alt="Logo"
              className="img-fluid mt-4"
            />
          </div>
          <ul className="nav flex-column">
            {authrztn.includes("Dashboard-View") && (
              <li className="nav-item">
                <Link
                  to="/dashboard"
                  className={`nav-link ${
                    location.pathname === "/dashboard" ? "active" : ""
                  }`}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "0.5rem",
                    }}
                  >
                    <i
                      className="fa-solid fa-house"
                      style={{ marginTop: "3px", flexShrink: 0 }}
                    ></i>
                    <span>Operations overview / Dashboard</span>
                  </span>
                </Link>
              </li>
            )}

            {(authrztn.includes("Invoices-View") ||
              authrztn.includes("LocalCollections-View") ||
              authrztn.includes("OverseasCollections-View") ||
              authrztn.includes("Customers-View")) && (
              <li className="nav-item">
                <div
                  className={`nav-link ${salesOpen ? "active" : ""}`}
                  onClick={(e) => handleNavClick(e, "sales")}
                  style={{ cursor: "pointer" }}
                >
                  <span>
                    <i className="fa-solid fa-user me-2"></i>
                    Sales Order
                  </span>
                  <i
                    className={`fas fa-angle-down ${
                      salesOpen ? "rotate-icon" : ""
                    }`}
                  ></i>
                </div>
                {salesOpen && (
                  <ul className="nav flex-column ms-3" data-title="Sales Order">
                    {authrztn.includes("Invoices-View") && (
                      <li className="nav-item">
                        <Link
                          to="/sales/invoices"
                          className={`nav-link ${
                            location.pathname.startsWith("/sales/invoices") ||
                            location.pathname.startsWith(
                              "/sales/create-invoice",
                            ) ||
                            location.pathname.startsWith(
                              "/sales/invoice-update",
                            ) ||
                            location.pathname.startsWith(
                              "/sales/invoice-payment",
                            )
                              ? "active"
                              : ""
                          }`}
                        >
                          Sales Management
                        </Link>
                      </li>
                    )}
                    {authrztn.includes("LocalCollections-View") && (
                      <li className="nav-item">
                        <Link
                          to="/sales/local-collections"
                          className={`nav-link ${
                            location.pathname.startsWith(
                              "/sales/local-collections",
                            ) ||
                            location.pathname.startsWith(
                              "/sales/local-bulk-collection",
                            ) ||
                            location.pathname.startsWith(
                              "/sales/overseas-bulk-collection",
                            ) ||
                            location.pathname.startsWith(
                              "/sales/view-local-bulk-collection",
                            )
                              ? "active"
                              : ""
                          }`}
                        >
                          Sales Collection
                        </Link>
                      </li>
                    )}
                    {authrztn.includes("Customers-View") && (
                      <li className="nav-item">
                        <Link
                          to="/sales/customers"
                          className={`nav-link ${
                            location.pathname.startsWith("/sales/customers")
                              ? "active"
                              : ""
                          }`}
                        >
                          Customers
                        </Link>
                      </li>
                    )}
                  </ul>
                )}
              </li>
            )}
            {(authrztn.includes("Payable-View") ||
              authrztn.includes("LocalPurchase-View") ||
              authrztn.includes("Vendors-View")) && (
              <li className="nav-item">
                <div
                  className={`nav-link ${purchasesOpen ? "active" : ""}`}
                  onClick={(e) => handleNavClick(e, "purchases")}
                  style={{ cursor: "pointer" }}
                >
                  <span>
                    <i className="fa-solid fa-credit-card me-2"></i>
                    Purchase Order
                  </span>
                  <i
                    className={`fas fa-angle-down ${
                      purchasesOpen ? "rotate-icon" : ""
                    }`}
                  ></i>
                </div>
                {purchasesOpen && (
                  <ul
                    className="nav flex-column ms-3"
                    data-title="Purchase Order"
                  >
                    {authrztn.includes("Payable-View") && (
                      <li className="nav-item">
                        <Link
                          to="/purchases/payable"
                          className={`nav-link ${
                            (hasPageParam &&
                              location.pathname.startsWith(
                                "/purchases/payable",
                              )) ||
                            location.pathname.startsWith(
                              "/purchases/payable",
                            ) ||
                            location.pathname.startsWith(
                              "/purchases/create_payable",
                            ) ||
                            location.pathname.startsWith(
                              "/purchases/view_payable",
                            )
                              ? "active"
                              : ""
                          }`}
                        >
                          Purchase Management
                        </Link>
                      </li>
                    )}
                    {authrztn.includes("LocalPurchase-View") && (
                      <li className="nav-item">
                        <Link
                          to="/purchases/local-purchase"
                          className={`nav-link ${
                            (hasPageParam &&
                              location.pathname.startsWith(
                                "/purchases/local-purchase",
                              )) ||
                            location.pathname.startsWith(
                              "/purchases/local-purchase",
                            ) ||
                            location.pathname.startsWith(
                              "/purchases/local-purchase-pay",
                            ) ||
                            location.pathname.startsWith(
                              "/Purchases/bulk-payable/local",
                            ) ||
                            location.pathname.startsWith(
                              "/Purchases/bulk-payable/overseas",
                            ) ||
                            location.pathname.startsWith(
                              "/Purchases/view-bulk-payable/local",
                            ) ||
                            location.pathname.startsWith(
                              "/Purchases/view-bulk-payable/overseas",
                            )
                              ? "active"
                              : ""
                          }`}
                        >
                          Purchase
                        </Link>
                      </li>
                    )}
                    {authrztn.includes("Vendors-View") && (
                      <li className="nav-item">
                        <Link
                          to="/purchases/vendors"
                          className={`nav-link ${
                            location.pathname.startsWith(
                              "/purchases/vendors",
                            ) ||
                            location.pathname.startsWith(
                              "/purchases/vendor-update",
                            )
                              ? "active"
                              : ""
                          }`}
                        >
                          Supplier
                        </Link>
                      </li>
                    )}
                  </ul>
                )}
              </li>
            )}
            {(authrztn.includes("BankTransactions-View") ||
              authrztn.includes("OutstandingCheck-View") ||
              authrztn.includes("IssuedCheck-View") ||
              authrztn.includes("AccountingList-View") ||
              authrztn.includes("BankBudgeting-View") ||
              authrztn.includes("OtherIncome-View")) && (
              <li className="nav-item">
                <div
                  className={`nav-link ${accountsOpen ? "active" : ""}`}
                  onClick={(e) => handleNavClick(e, "accounts")}
                  style={{ cursor: "pointer" }}
                >
                  <span>
                    <i className="fa-regular fa-folder-open"></i>
                    Cash Account
                  </span>
                  <i
                    className={`fas fa-angle-down ${
                      accountsOpen ? "rotate-icon" : ""
                    }`}
                  ></i>
                </div>
                {accountsOpen && (
                  <ul
                    className="nav flex-column ms-3"
                    data-title="Cash Account"
                  >
                    {authrztn.includes("BankTransactions-View") && (
                      <li className="nav-item">
                        <Link
                          to="/accounts/bank-transaction"
                          className={`nav-link ${
                            location.pathname === "/accounts/bank-transaction"
                              ? "active"
                              : ""
                          }`}
                        >
                          Bank Transactions
                        </Link>
                      </li>
                    )}
                    {authrztn.includes("OutstandingCheck-View") && (
                      <li className="nav-item">
                        <Link
                          to="/accounts/outstanding-check"
                          className={`nav-link ${
                            location.pathname === "/accounts/outstanding-check"
                              ? "active"
                              : ""
                          }`}
                        >
                          Receivable Checks
                        </Link>
                      </li>
                    )}
                    {authrztn.includes("IssuedCheck-View") && (
                      <li className="nav-item">
                        <Link
                          to="/accounts/issued-check-account"
                          className={`nav-link ${
                            location.pathname ===
                            "/accounts/issued-check-account"
                              ? "active"
                              : ""
                          }`}
                        >
                          Issued Checks
                        </Link>
                      </li>
                    )}
                    {authrztn.includes("AccountingList-View") && (
                      <li className="nav-item">
                        <Link
                          to="/accounts/account-list1"
                          className={`nav-link ${
                            location.pathname.startsWith(
                              "/accounts/account-list1",
                            ) ||
                            location.pathname.startsWith(
                              "/accounts/view-accountlist",
                            )
                              ? "active"
                              : ""
                          }`}
                        >
                          Accounting List
                        </Link>
                      </li>
                    )}
                    {authrztn.includes("BankBudgeting-View") && (
                      <li className="nav-item">
                        <Link
                          to="/accounts/bank-budgeting"
                          className={`nav-link ${
                            location.pathname === "/accounts/bank-budgeting"
                              ? "active"
                              : ""
                          }`}
                        >
                          Bank Budgeting
                        </Link>
                      </li>
                    )}
                    {authrztn.includes("OtherIncome-View") && (
                      <li className="nav-item">
                        <Link
                          to="/accounts/other-income"
                          className={`nav-link ${
                            location.pathname.startsWith(
                              "/accounts/other-income",
                            ) ||
                            location.pathname.startsWith(
                              "/accounts/viewOtherIncome",
                            ) ||
                            location.pathname.startsWith(
                              "/accounts/add-otherIncome",
                            )
                              ? "active"
                              : ""
                          }`}
                        >
                          Other Income
                        </Link>
                      </li>
                    )}
                  </ul>
                )}
              </li>
            )}
            {(authrztn.includes("StockManagement-View") ||
              authrztn.includes("ProductList-View") ||
              authrztn.includes("Productions-View") ||
              authrztn.includes("StockTransfer-View") ||
              authrztn.includes("InventoryCounting-View")) && (
              <li className="nav-item">
                <div
                  className={`nav-link ${inventoryOpen ? "active" : ""}`}
                  onClick={(e) => handleNavClick(e, "inventory")}
                  style={{ cursor: "pointer" }}
                >
                  <span>
                    <i className="fas fa-box me-2"></i>
                    Inventory
                  </span>
                  <i
                    className={`fas fa-angle-down ${
                      inventoryOpen ? "rotate-icon" : ""
                    }`}
                  ></i>
                </div>
                {inventoryOpen && (
                  <ul className="nav flex-column ms-3" data-title="Inventory">
                    {authrztn.includes("StockManagement-View") && (
                      <li className="nav-item">
                        <Link
                          to="/inventory/stock-management"
                          className={`nav-link ${
                            location.pathname.startsWith(
                              "/inventory/stock-management",
                            ) ||
                            location.pathname.startsWith(
                              "/inventory/stockMangement/rawMaterialUpdate",
                            )
                              ? "active"
                              : ""
                          }`}
                        >
                          Stock Management
                        </Link>
                      </li>
                    )}
                    {authrztn.includes("ProductList-View") && (
                      <li className="nav-item">
                        <Link
                          to="/inventory/product-list"
                          className={`nav-link ${
                            location.pathname.startsWith(
                              "/inventory/product-list",
                            ) ||
                            location.pathname.startsWith(
                              "/inventory/create-product",
                            ) ||
                            location.pathname.startsWith(
                              "/inventory/update-product",
                            )
                              ? "active"
                              : ""
                          }`}
                        >
                          Product List
                        </Link>
                      </li>
                    )}
                    {authrztn.includes("Productions-View") && (
                      <li className="nav-item">
                        <Link
                          to="/inventory/productions"
                          className={`nav-link ${
                            location.pathname.startsWith(
                              "/inventory/productions",
                            ) ||
                            location.pathname.startsWith(
                              "/inventory/productions-form",
                            ) ||
                            location.pathname.startsWith(
                              "/inventory/ProductionsView",
                            )
                              ? "active"
                              : ""
                          }`}
                        >
                          Production
                        </Link>
                      </li>
                    )}
                    {authrztn.includes("StockTransfer-View") && (
                      <li className="nav-item">
                        <Link
                          to="/inventory/stock-transfer"
                          className={`nav-link ${
                            location.pathname.startsWith(
                              "/inventory/stock-transfer",
                            ) ||
                            location.pathname.startsWith(
                              "/inventory/create-stock-transfer",
                            ) ||
                            location.pathname.startsWith(
                              "/inventory/view-stock-transfer",
                            )
                              ? "active"
                              : ""
                          }`}
                        >
                          Stock Transfer
                        </Link>
                      </li>
                    )}
                    {authrztn.includes("InventoryCounting-View") && (
                      <li className="nav-item">
                        <Link
                          to="/inventory/inventory-counting"
                          className={`nav-link ${
                            location.pathname.startsWith(
                              "/inventory/inventory-counting",
                            ) ||
                            location.pathname.startsWith(
                              "/inventory/inventory-counting-create",
                            )
                              ? "active"
                              : ""
                          }`}
                        >
                          Inventory Counting
                        </Link>
                      </li>
                    )}
                  </ul>
                )}
              </li>
            )}
            {(authrztn.includes("CashFlow-View") ||
              authrztn.includes("Expenses-View") ||
              authrztn.includes("LocalExpenses-View") ||
              authrztn.includes("FixedAssets-View") ||
              authrztn.includes("AssetAccount-View") ||
              authrztn.includes("Liability-View") ||
              authrztn.includes("Equity-View") ||
              authrztn.includes("Monthly-View")) && (
              <li className="nav-item">
                <div
                  className={`nav-link ${accountingOpen ? "active" : ""}`}
                  onClick={(e) => handleNavClick(e, "accounting")}
                  style={{ cursor: "pointer" }}
                >
                  <span>
                    <i className="fas fa-chart-line me-2"></i>
                    Accounting
                  </span>
                  <i
                    className={`fas fa-angle-down ${
                      accountingOpen ? "rotate-icon" : ""
                    }`}
                  ></i>
                </div>
                {accountingOpen && (
                  <ul className="nav flex-column ms-3" data-title="Accounting">
                    {authrztn.includes("CashFlow-View") && (
                      <li className="nav-item">
                        <Link
                          to="/accounting/cash-flow"
                          className={`nav-link ${
                            location.pathname === "/accounting/cash-flow"
                              ? "active"
                              : ""
                          }`}
                        >
                          Cash Flow
                        </Link>
                      </li>
                    )}
                    {authrztn.includes("Expenses-View") && (
                      <li className="nav-item">
                        <Link
                          to="/accounting/expenses"
                          className={`nav-link ${
                            location.pathname.startsWith(
                              "/accounting/expenses",
                            ) ||
                            location.pathname.startsWith(
                              "/accounting/add-expenses",
                            ) ||
                            location.pathname.startsWith(
                              "/accounting/view-expenses",
                            )
                              ? "active"
                              : ""
                          }`}
                        >
                          Create Expenses
                        </Link>
                      </li>
                    )}
                    {authrztn.includes("LocalExpenses-View") && (
                      <li className="nav-item">
                        <Link
                          to="/accounting/local-expenses"
                          className={`nav-link ${
                            location.pathname.startsWith(
                              "/accounting/local-expenses",
                            ) ||
                            location.pathname.startsWith(
                              "/accounting/pay-expenses/local",
                            ) ||
                            location.pathname.startsWith(
                              "/accounting/pay-expenses/overseas",
                            ) ||
                            location.pathname.startsWith(
                              "/accounting/view-pay-expenses/local",
                            ) ||
                            location.pathname.startsWith(
                              "/accounting/view-pay-expenses/overseas",
                            )
                              ? "active"
                              : ""
                          }`}
                        >
                          Closed Expenses
                        </Link>
                      </li>
                    )}
                    {authrztn.includes("FixedAssets-View") && (
                      <li className="nav-item">
                        <Link
                          to="/accounting/fixedAsset"
                          className={`nav-link ${
                            location.pathname.startsWith(
                              "/accounting/fixedAsset",
                            ) ||
                            location.pathname.startsWith(
                              "/accounting/create-fixed-assets",
                            )
                              ? "active"
                              : ""
                          }`}
                        >
                          Fixed Assets
                        </Link>
                      </li>
                    )}
                    {authrztn.includes("AssetAccount-View") && (
                      <li className="nav-item">
                        <Link
                          to="/accounting/assetaccount-list1"
                          className={`nav-link ${
                            location.pathname.startsWith(
                              "/accounting/assetaccount",
                            ) ||
                            location.pathname.startsWith(
                              "/accounting/create-asset-account",
                            ) ||
                            location.pathname.startsWith(
                              "/accounting/view-assetAccount",
                            )
                              ? "active"
                              : ""
                          }`}
                        >
                          Asset Account
                        </Link>
                      </li>
                    )}
                    {authrztn.includes("Liability-View") && (
                      <li className="nav-item">
                        <Link
                          to="/accounting/liabilities1"
                          className={`nav-link ${
                            location.pathname.startsWith(
                              "/accounting/liabilities1",
                            ) ||
                            location.pathname.startsWith(
                              "/accounting/create-liabilities1",
                            ) ||
                            location.pathname.startsWith(
                              "/accounting/view-liabilityAccount",
                            )
                              ? "active"
                              : ""
                          }`}
                        >
                          Liabilities
                        </Link>
                      </li>
                    )}
                    {authrztn.includes("Equity-View") && (
                      <li className="nav-item">
                        <Link
                          to="/accounting/equity"
                          className={`nav-link ${
                            location.pathname.startsWith(
                              "/accounting/equity",
                            ) ||
                            location.pathname.startsWith(
                              "/accounting/create-equity",
                            ) ||
                            location.pathname.startsWith(
                              "/accounting/view-equityAccount",
                            )
                              ? "active"
                              : ""
                          }`}
                        >
                          Owners' Equity
                        </Link>
                      </li>
                    )}
                    {authrztn.includes("Monthly-View") && (
                      <li className="nav-item">
                        <Link
                          to="/accounting/cutoff"
                          className={`nav-link ${
                            location.pathname.startsWith(
                              "/accounting/cutoff",
                            ) ||
                            location.pathname.startsWith(
                              "/accounting/view-cutoff",
                            )
                              ? "active"
                              : ""
                          }`}
                        >
                          Monthly Accounting Cutoff
                        </Link>
                      </li>
                    )}

                    {authrztn.includes("Retained-View") && (
                      <li className="nav-item">
                        <Link
                          to="/accounting/profit-distribution"
                          className={`nav-link ${
                            location.pathname.startsWith(
                              "/accounting/profit-distribution",
                            ) ||
                            location.pathname.startsWith(
                              "/accounting/profit-distribution",
                            )
                              ? "active"
                              : ""
                          }`}
                        >
                          Profit Distribution
                        </Link>
                      </li>
                    )}
                  </ul>
                )}
              </li>
            )}
            {authrztn.includes("Reporting-View") && (
              <li className="nav-item">
                <div
                  className={`nav-link ${taxMngntOpen ? "active" : ""}`}
                  onClick={(e) => handleNavClick(e, "taxmngnt")}
                  style={{ cursor: "pointer" }}
                >
                  <span>
                    <i className="fa-solid fa-circle-dollar-to-slot"></i>
                    Tax Management
                  </span>
                  <i
                    className={`fas fa-angle-down ${
                      taxMngntOpen ? "rotate-icon" : ""
                    }`}
                  ></i>
                </div>
                {taxMngntOpen && (
                  <ul
                    className="nav flex-column ms-3"
                    data-title="Tax Management"
                  >
                    <li className="nav-item">
                      <Link
                        to="/taxmngnt/tax-settings"
                        className={`nav-link ${
                          location.pathname === "/taxmngnt/tax-settings"
                            ? "active"
                            : ""
                        }`}
                      >
                        Withholding Tax Settings
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        style={{
                          cursor: "not-allowed",
                          backgroundColor: "var(--dm-surface-2, #e9ecef)",
                        }}
                        className={`nav-link ${
                          location.pathname === "/taxmngnt/tax-settingss"
                            ? "active"
                            : ""
                        }`}
                      >
                        Withholding Tax Report <i class="fa-solid fa-lock"></i>
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
            )}

            <li className="nav-item">
              <div
                className={`nav-link ${reportingOpen ? "active" : ""}`}
                onClick={(e) => handleNavClick(e, "reports")}
                style={{ cursor: "pointer" }}
              >
                <span>
                  <i className="fas fa-chart-bar me-2"></i>
                  Reporting
                </span>
                <i
                  className={`fas fa-angle-down ${
                    reportingOpen ? "rotate-icon" : ""
                  }`}
                ></i>
              </div>
              {reportingOpen && (
                <ul className="nav flex-column ms-3" data-title="Reporting">
                  <li className="nav-item d-none">
                    <div
                      className={`nav-link ${
                        statementReportsOpen ? "active" : ""
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleSubMenu("statementReports");
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <span>Statement Reports</span>
                      <i
                        className={`fa-solid fa-caret-down ${
                          statementReportsOpen ? "rotate-icon" : ""
                        }`}
                      ></i>
                    </div>
                    {statementReportsOpen && (
                      <ul
                        className="nav flex-column ms-3"
                        data-title="Statement Reports"
                      >
                        <li className="nav-item">
                          <Link
                            to="/reports/statement/balance-sheet"
                            className={`nav-link ${
                              location.pathname ===
                              "/reports/statement/balance-sheet"
                                ? "active"
                                : ""
                            }`}
                          >
                            Balance Sheet
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/reports/statement/production-loss"
                            className={`nav-link ${
                              location.pathname ===
                              "/reports/statement/production-loss"
                                ? "active"
                                : ""
                            }`}
                          >
                            Production Loss
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/reports/statement/expenses-report"
                            className={`nav-link ${
                              location.pathname ===
                              "/reports/statement/expenses-report"
                                ? "active"
                                : ""
                            }`}
                          >
                            Expenses Report
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/reports/statement/income-profit"
                            className={`nav-link ${
                              location.pathname ===
                              "/reports/statement/income-profit"
                                ? "active"
                                : ""
                            }`}
                          >
                            Income Profit
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/reports/statement/income-profit-branch"
                            className={`nav-link ${
                              location.pathname ===
                              "/reports/statement/income-profit-branch"
                                ? "active"
                                : ""
                            }`}
                          >
                            Income Profit Branches
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/reports/statement/income-profit-client"
                            className={`nav-link ${
                              location.pathname ===
                              "/reports/statement/income-profit-client"
                                ? "active"
                                : ""
                            }`}
                          >
                            Income Profit Clients
                          </Link>
                        </li>

                        <li className="nav-item">
                          <Link
                            to="/reports/statement/boss-report"
                            className={`nav-link ${
                              location.pathname ===
                              "/reports/statement/boss-report"
                                ? "active"
                                : ""
                            }`}
                          >
                            Boss Report
                          </Link>
                        </li>
                      </ul>
                    )}
                  </li>
                  <li className="nav-item d-none">
                    <div
                      className={`nav-link ${auditReportsOpen ? "active" : ""}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleSubMenu("auditReports");
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <span>Audit Reports</span>
                      <i
                        className={`fa-solid fa-caret-down  ${
                          auditReportsOpen ? "rotate-icon" : ""
                        }`}
                      ></i>
                    </div>
                    {auditReportsOpen && (
                      <ul
                        className="nav flex-column ms-3"
                        data-title="Audit Reports"
                      >
                        <li className="nav-item">
                          <Link
                            to="/reports/audit/journal-list"
                            className={`nav-link ${
                              location.pathname ===
                              "/reports/audit/journal-list"
                                ? "active"
                                : ""
                            }`}
                          >
                            Journal List Report
                          </Link>
                        </li>
                      </ul>
                    )}
                  </li>
                  <li className="nav-item d-none">
                    <div
                      className={`nav-link ${
                        businessPartnerReportsOpen ? "active" : ""
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleSubMenu("businessPartnerReports");
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <span className="nav-link-sm">
                        Business Partner Reports
                      </span>
                      <i
                        className={`fa-solid fa-caret-down  ${
                          businessPartnerReportsOpen ? "rotate-icon" : ""
                        }`}
                      ></i>
                    </div>
                    {businessPartnerReportsOpen && (
                      <ul
                        className="nav flex-column ms-3"
                        data-title="Business Partner Reports"
                      >
                        <li className="nav-item">
                          <Link
                            to="/reports/business-partner/receiving-reports"
                            className={`nav-link ${
                              location.pathname ===
                              "/reports/business-partner/receiving-reports"
                                ? "active"
                                : ""
                            }`}
                          >
                            Receiving Reports
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/reports/business-partner/payable"
                            className={`nav-link ${
                              location.pathname ===
                              "/reports/business-partner/payable"
                                ? "active"
                                : ""
                            }`}
                          >
                            Payable
                          </Link>
                        </li>
                      </ul>
                    )}
                  </li>
                  <li className="nav-item d-none">
                    <Link
                      to="/reports/inventory-report"
                      className={`nav-link ${
                        location.pathname === "/reports/inventory-report"
                          ? "active"
                          : ""
                      }`}
                    >
                      Inventory Reports
                    </Link>
                  </li>

                  {authrztn.includes("BossReport-View") && (
                    <li className="nav-item">
                      <div
                        className={`nav-link  ${
                          generalReportsOpen ? "active" : ""
                        }`}
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleSubMenu("generalReports");
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <span>Boss Report</span>
                        <i
                          className={`fa-solid fa-caret-down ${
                            generalReportsOpen ? "rotate-icon" : ""
                          }`}
                        ></i>
                      </div>
                      {generalReportsOpen && (
                        <ul
                          className="nav flex-column ms-3"
                          data-title="Boss Report"
                        >
                          <li className="nav-item d-none">
                            <Link
                              to="/reports/general/po-reports"
                              className={`nav-link ${
                                location.pathname ===
                                "/reports/general/po-reports"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              P.O. Reports Supplier
                            </Link>
                          </li>
                          <li className="nav-item d-none">
                            <Link
                              to="/reports/general/sales-reports"
                              className={`nav-link ${
                                location.pathname ===
                                "/reports/general/sales-reports"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              Sales Reports
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="/reports/general/boss-report"
                              className={`nav-link ${
                                location.pathname ===
                                "/reports/general/boss-report"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              Boss Report
                            </Link>
                          </li>
                        </ul>
                      )}
                    </li>
                  )}

                  {(authrztn.includes("PurchaseReport-View") ||
                    authrztn.includes("ProductionReport-View") ||
                    authrztn.includes("SalesReport-View") ||
                    authrztn.includes("InventoryReport-View") ||
                    authrztn.includes("ExpensesReport-View") ||
                    authrztn.includes("IncomeStatement-View") ||
                    authrztn.includes("BalanceSheet-View") ||
                    authrztn.includes("ProfitLoss-View") ||
                    authrztn.includes("AccountReport-View") ||
                    authrztn.includes("UserReport-View")) && (
                    <li className="nav-item">
                      <div
                        className={`nav-link ${newReportsOpen ? "active" : ""}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleSubMenu("newReports");
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <span>Standard Reports</span>
                        <i
                          className={`fa-solid fa-caret-down ${
                            newReportsOpen ? "rotate-icon" : ""
                          }`}
                        ></i>
                      </div>
                      {newReportsOpen && (
                        <ul
                          className="nav flex-column ms-3"
                          data-title="Standard Reports"
                        >
                          {authrztn.includes("PurchaseReport-View") && (
                            <li className="nav-item">
                              <Link
                                to="/reports/new-report/purchase_report"
                                className={`nav-link ${
                                  location.pathname ===
                                  "/reports/new-report/purchase_report"
                                    ? "active"
                                    : ""
                                }`}
                              >
                                Purchase Report
                              </Link>
                            </li>
                          )}
                          {authrztn.includes("ProductionReport-View") && (
                            <li className="nav-item">
                              <Link
                                to="/reports/new-report/production_report"
                                className={`nav-link ${
                                  location.pathname ===
                                  "/reports/new-report/production_report"
                                    ? "active"
                                    : ""
                                }`}
                              >
                                Production Report
                              </Link>
                            </li>
                          )}
                          {authrztn.includes("SalesReport-View") && (
                            <li className="nav-item">
                              <Link
                                to="/reports/new-report/sales_report"
                                className={`nav-link ${
                                  location.pathname ===
                                  "/reports/new-report/sales_report"
                                    ? "active"
                                    : ""
                                }`}
                              >
                                Sales Report
                              </Link>
                            </li>
                          )}
                          {authrztn.includes("InventoryReport-View") && (
                            <li className="nav-item">
                              <Link
                                to="/reports/new-report/inventory_report"
                                className={`nav-link ${
                                  location.pathname ===
                                  "/reports/new-report/inventory_report"
                                    ? "active"
                                    : ""
                                }`}
                              >
                                Inventory Report
                              </Link>
                            </li>
                          )}
                          {authrztn.includes("ExpensesReport-View") && (
                            <li className="nav-item">
                              <Link
                                to="/reports/new-report/expenses_report"
                                className={`nav-link ${
                                  location.pathname ===
                                  "/reports/new-report/expenses_report"
                                    ? "active"
                                    : ""
                                }`}
                              >
                                Expenses Report
                              </Link>
                            </li>
                          )}

                          {authrztn.includes("IncomeStatement-View") && (
                            <li className="nav-item">
                              <Link
                                to="/reports/new-report/income_report"
                                className={`nav-link ${
                                  location.pathname ===
                                  "/reports/new-report/income_report"
                                    ? "active"
                                    : ""
                                }`}
                              >
                                Income Statement
                              </Link>
                            </li>
                          )}

                          {authrztn.includes("BalanceSheet-View") && (
                            <li className="nav-item">
                              <Link
                                to="/reports/new-report/balance_sheet"
                                className={`nav-link ${
                                  location.pathname.startsWith(
                                    "/reports/new-report/balance_sheet",
                                  )
                                    ? "active"
                                    : ""
                                }`}
                              >
                                Final Balance Sheet
                              </Link>
                            </li>
                          )}
                          {authrztn.includes("ProfitLoss-View") && (
                            <li className="nav-item">
                              <Link
                                to="/reports/new-report/profit_loss"
                                className={`nav-link ${
                                  location.pathname.startsWith(
                                    "/reports/new-report/prodit_loss",
                                  )
                                    ? "active"
                                    : ""
                                }`}
                              >
                                Foreign Exchange Gain/Loss
                              </Link>
                            </li>
                          )}
                          {authrztn.includes("AccountReport-View") && (
                            <li className="nav-item">
                              <Link
                                to="/reports/new-report/account_reports"
                                className={`nav-link ${
                                  location.pathname ===
                                  "/reports/new-report/account_reports"
                                    ? "active"
                                    : ""
                                }`}
                              >
                                Account Reports
                              </Link>
                            </li>
                          )}
                          {authrztn.includes("UserReport-View") && (
                            <li className="nav-item">
                              <Link
                                to="/reports/new-report/user_reports"
                                className={`nav-link ${
                                  location.pathname ===
                                  "/reports/new-report/user_reports"
                                    ? "active"
                                    : ""
                                }`}
                              >
                                User Reports
                              </Link>
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}
                </ul>
              )}
            </li>
            {(authrztn.includes("ExpensesType1-View") ||
              authrztn.includes("ExpensesType2-View")) && (
              <li className="nav-item">
                <div
                  className={`nav-link ${contentOpen ? "active" : ""}`}
                  onClick={(e) => handleNavClick(e, "content")}
                  style={{ cursor: "pointer" }}
                >
                  <span>
                    <i className="fa-solid fa-gears"></i>
                    Content Management
                  </span>
                  <i
                    className={`fas fa-angle-down ${
                      contentOpen ? "rotate-icon" : ""
                    }`}
                  ></i>
                </div>
                {contentOpen && (
                  <ul
                    className="nav flex-column ms-3"
                    data-title="Content Management"
                  >
                    {authrztn.includes("ExpensesType1-View") && (
                      <li className="nav-item">
                        <Link
                          to="/content/expenses1"
                          className={`nav-link ${
                            location.pathname === "/content/expenses1"
                              ? "active"
                              : ""
                          }`}
                        >
                          Expense Type
                        </Link>
                      </li>
                    )}
                    {authrztn.includes("ExpensesType2-View") && (
                      <li className="nav-item">
                        <Link
                          to="/content/expenses2"
                          className={`nav-link ${
                            location.pathname === "/content/expenses2"
                              ? "active"
                              : ""
                          }`}
                        >
                          Expense Sub-Type
                        </Link>
                      </li>
                    )}
                  </ul>
                )}
              </li>
            )}
            {(authrztn.includes("RBAC-View") ||
              authrztn.includes("Branches-View") ||
              authrztn.includes("UserManagement-View") ||
              authrztn.includes("Currency-View") ||
              authrztn.includes("Notifications-View")) && (
              <li className="nav-item">
                <div
                  className={`nav-link ${settingsOpen ? "active" : ""}`}
                  onClick={(e) => handleNavClick(e, "settings")}
                  style={{ cursor: "pointer" }}
                >
                  <span>
                    <i className="fa-solid fa-gear"></i>
                    Settings
                  </span>
                  <i
                    className={`fas fa-angle-down ${
                      settingsOpen ? "rotate-icon" : ""
                    }`}
                  ></i>
                </div>
                {settingsOpen && (
                  <ul className="nav flex-column ms-3" data-title="Settings">
                    {authrztn.includes("RBAC-View") && (
                      <li className="nav-item">
                        <Link
                          to="/settings/access-control"
                          className={`nav-link ${
                            location.pathname.startsWith(
                              "/settings/access-control",
                            ) ||
                            location.pathname.startsWith(
                              "/settings/create-rbac",
                            ) ||
                            location.pathname.startsWith(
                              "/settings/update-rbac",
                            )
                              ? "active"
                              : ""
                          }`}
                        >
                          Access Control
                        </Link>
                      </li>
                    )}
                    {userLoggedID === "11111111-1111-1111-1111-111111111111" &&
                      authrztn.includes("Branches-View") && (
                        <li className="nav-item">
                          <Link
                            to="/settings/branches"
                            className={`nav-link ${
                              location.pathname === "/settings/branches"
                                ? "active"
                                : ""
                            }`}
                          >
                            Company Branches
                          </Link>
                        </li>
                      )}
                    {authrztn.includes("UserManagement-View") && (
                      <li className="nav-item">
                        <Link
                          to="/settings/user-management"
                          className={`nav-link ${
                            location.pathname === "/settings/user-management"
                              ? "active"
                              : ""
                          }`}
                        >
                          User Management
                        </Link>
                      </li>
                    )}
                    {userLoggedID === "11111111-1111-1111-1111-111111111111" &&
                      authrztn.includes("Currency-View") && (
                        <li className="nav-item">
                          <Link
                            to="/settings/currency"
                            className={`nav-link ${
                              location.pathname === "/settings/currency"
                                ? "active"
                                : ""
                            }`}
                          >
                            Currency
                          </Link>
                        </li>
                      )}
                    {authrztn.includes("Notifications-View") && (
                      <li className="nav-item">
                        <Link
                          to="/settings/in-app-notification"
                          className={`nav-link ${
                            location.pathname ===
                            "/settings/in-app-notification"
                              ? "active"
                              : ""
                          }`}
                        >
                          In-app Notification
                        </Link>
                      </li>
                    )}
                  </ul>
                )}
              </li>
            )}
            {authrztn.includes("ActivityLog-View") && (
              <li className="nav-item">
                <Link
                  to="/activity-log"
                  className={`nav-link ${
                    location.pathname === "/activity-log" ? "active" : ""
                  }`}
                >
                  <span>
                    <i className="fa-solid fa-tv me-2"></i>
                    Activity Log
                  </span>
                </Link>
              </li>
            )}
            {authrztn.includes("AuditLog-View") && (
              <li className="nav-item">
                <Link
                  to="/audit-log"
                  className={`nav-link ${
                    location.pathname === "/audit-log" ? "active" : ""
                  }`}
                >
                  <span>
                    <i className="fa-solid fa-tv me-2"></i>
                    Audit Log
                  </span>
                </Link>
              </li>
            )}
            {authrztn.includes("11111111-1111-1111-1111-111111111111") && (
              <li className="nav-item">
                <Link
                  to="/migration"
                  className={`nav-link ${
                    location.pathname === "/migration" ? "active" : ""
                  }`}
                >
                  <span>
                    <i class="fa-solid fa-download me-2"></i>
                    Migration
                  </span>
                </Link>
              </li>
            )}
          </ul>
        </div>

        {/* Flyout popup – shown only when the sidebar is icon-only */}
        {isIconOnly && flyoutMenu && (
          <div
            ref={flyoutRef}
            className="sidebar-flyout"
            style={{ top: flyoutTop ?? flyoutMenu.top }}
            onClick={(e) => e.stopPropagation()}
          >
            {renderFlyout(flyoutMenu.key)}
          </div>
        )}
      </div>
    </>
  );
};

export default Sidebar;
